import {
  SHOPPING_LIST_ADD,
  SHOPPING_LIST_CLEAR,
  SHOPPING_LIST_INCREMENT,
  SHOPPING_LIST_DECREMENT,
  SHOPPING_LIST_REMOVE,
  SHOPPING_LIST_SET_QUANTITY,
} from '../Actions/ShoppingList.action';

const storageKey = 'shoppingList';
const initialState = () => {
  const state = JSON.parse(localStorage.getItem(storageKey));
  return state || [];
};

const shoppingList = (state = initialState(), action) => {
  const { type, payload } = action;
  let newState;
  switch (type) {
    case SHOPPING_LIST_ADD:
      
      if(payload!=undefined)
      {
        newState = [...state, { productId: payload, quantity: 1 }];
        saveStateToLocalStorage(newState);
        return newState;
      }
      return state;
     
    case SHOPPING_LIST_REMOVE:
      newState = [...state.filter((x) => x.productId != payload)];
      saveStateToLocalStorage(newState);
      return newState;
    case SHOPPING_LIST_INCREMENT:
      const row = state.find((x) => x.productId == payload.productId);
      row.quantity += payload.quantity;
      newState = [
        ...state.filter((x) => x.productId != payload.productId),
        { ...row },
      ];
      saveStateToLocalStorage(newState);
      return newState;
    case SHOPPING_LIST_DECREMENT:
      const row2 = state.find((x) => x.productId == payload.productId);
      row2.quantity -= payload.quantity;
      row2.quantity = Math.max(1, row2.quantity);
      newState = [
        ...state.filter((x) => x.productId != payload.productId),
        { ...row2 },
      ];
      saveStateToLocalStorage(newState);
      return newState;
    case SHOPPING_LIST_SET_QUANTITY:
      const row3 = state.find((x) => x.productId == payload.productId);
      row3.quantity = payload.quantity;
      row3.quantity = Math.max(1, row3.quantity);
      newState = [
        ...state.filter((x) => x.productId != payload.productId),
        { ...row3 },
      ];
      saveStateToLocalStorage(newState);
      return newState;
    case SHOPPING_LIST_CLEAR:
      saveStateToLocalStorage(null);
      return initialState();
    default:
      return state;
  }
};

const saveStateToLocalStorage = (state) => {
  if (!state) {
    localStorage.setItem(storageKey, null);
  } else {
    localStorage.setItem(storageKey, JSON.stringify(state));
  }
};

export default shoppingList;
